import React from 'react';
//import axios from 'axios';
//import api from './../../../services/api';
//import { user_token } from '../../../services/Auth';
import { NavLink } from 'react-router-dom';

//var token = localStorage.getItem(user_token);

export default class GetExam extends React.Component {
  state = {
    user: [],
    first: this.props._id,
  }

  render() {
    let {first} = this.state;
    const renderAuthButton = ()=>{
      if(first){
        return <NavLink to={{pathname: `/prontuario_inicial/` + this.props.exam_id}}>
        <button id="option-PS-Painel">Acessar Prontuário</button></NavLink>
      } else{
        return <NavLink to={{pathname: `/monitoramento/` + this.props.exam_id}}>
        <button id="option-PS-Painel">Acessar Prontuário</button></NavLink>
      }
    }
    return (
      <ul>
        <>
          {renderAuthButton()}
        </>
      </ul>
    )
  }
}